<template>
  <b-card no-body tag="article" class="product-card text-center">
    <router-link :to="productRoute">
      <b-card-img
        :src="(product.picture && product.picture.picture)? product.picture.picture: fallback"
        :alt="product.description"
        top
        class="w-75"
        @error="imageLoadError"
      ></b-card-img>
      <div class="info-box">
        <div class="info-label" :to="productRoute">
          <span>
            <font-awesome-icon icon="eye" />
          </span>
        </div>
      </div>
    </router-link>
    <b-card-body class="d-flex flex-column">
      <div class="mt-auto">
        <b-container fluid v-if="price">
          <b-row align-v="end">
            <b-col class="m-0 p-0">
              <div v-if="discount && discountPackQuantity" class="discount-type">
                ({{ $t("product_card.pack_offer") }} x{{ discountPackQuantity }})
              </div>
              <div v-if="discount" class="no-discount-price">
                {{ $formatMoney(priceBefore, currency) }}
              </div>
              <div class="product-price">
                {{ $formatMoney(price, currency) }}
              </div>
            </b-col>
            <b-col v-if="discount" cols="12" md="4" class="m-0 p-0">
              <div class="discount-box px-2 py-1 mx-4 mx-md-0">
                -{{ discountPercent }}%
              </div>
            </b-col>
          </b-row>
        </b-container>
        <div class="product-name mt-3">
          <router-link :to="productRoute">{{ product.description || '---' }}</router-link>
        </div>
        <div class="mt-4 mt-md-5 mb-2 d-flex align-content-center flex-wrap justify-content-center w-100">
          <vue-element-loading :active="to_cart_loading" />
          <b-button
            variant="cart"
            :disabled="!price"
            @click="buyProduct()"
          >
            {{ $t('product_card.add') }}
          </b-button>
          <b-button
            variant="buy"
            :disabled="!price"
            @click="buyProduct(1, true)"
          >
            {{ $t('product_card.buy') }}
          </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>


<script>
import { ProductCardMixin } from "@/mixins/ProductCardMixin";

export default {
  name: "product-card",
  mixins: [ProductCardMixin],
  fallbackI18n: {
    messages: {
      und: {
        product_card: {
          add: "Add",
          buy: "Buy",
          pack_offer: "Pack Offer",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.product-card {
  background-color: $main-bg-color;
  max-width: $product-card-max-width;
  min-height: 25rem;
}

.product-price {
  font-size: $font-size-medium * 1.4;
  font-weight: bold;
}

.product-name {
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.product-name a {
  color: $text-main-color;
  text-decoration: none;
}

.info-box {
  height: 20%;
  margin-left: auto;
  overflow: hidden;
  position: absolute;
  right: -1px;
  top: -1px;
  width: 35%;
}

.info-label {
  background-color: $corp-color2;
  bottom: 25%;
  height: 146%;
  left: 50%;
  position: absolute;
  transform: rotate(-45deg);
  width: 100%;
}

.info-label span {
  color: white;
  font-size: 1.2rem;
  left: 11%;
  position: absolute;
  top: 37%;
  transform: rotate(45deg);
}

.discount-type {
  color: $grey5-color;
}

.no-discount-price {
  color: $grey5-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
  text-decoration: line-through;
}

.discount-box {
  background-color: $discount-bg-color;
  color: $white;
  font-size: $font-size-medium * 1.3;
  font-weight: bold;
}

@include media-breakpoint-down(sm) {
  .product-card {
    max-width: $product-card-max-width * 0.6;
    min-height: 10rem;
  }

  .product-price {
    font-size: $font-size-base * 1.2;
  }

  .product-name {
    font-size: $font-size-base * 1;
  }

  .info-label span {
    font-size: 0.9rem;
    left: 8%;
  }

  .discount-box {
    font-size: $font-size-base * 1.1;
  }
}
</style>
